export default __webpack_public_path__ + "static/media/lung_plot_male.0b393ea3.png";